import type { Plan } from "@/features/auth/types/plan.type";
import type { UserResponse } from "@/shared/types/";

/**
 * The part of the Mes Yeaties question shared by every place that asks it; who
 * is asked again after a refusal is each place's own rule.
 */
export const canBeAskedAboutMesYeaties = (user: UserResponse | null, plan: Plan | null): boolean =>
  plan?.features?.service_cashback === true
  // The API refuses the writes of an impersonated session: asking would only fail.
  && user?.employee?.impersonation?.active !== true;
